import React from 'react';
import {styled} from '@mui/material';
import {Description} from '@mui/icons-material';

const Holder = styled('div')(({theme}) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.grey['200'],
  color: theme.palette.common.white,
  display: 'flex',
  borderRadius: 4,
  justifyContent: 'center',
  padding: '1px 8px 1px 4px',

  ' > svg': {
    marginRight: '2px',
    width: theme.spacing(2),
  },

  '&.noted': {
    backgroundColor: theme.palette.grey['400'],
  }
}));

const Count = styled('span')(({theme}) => ({
  fontFamily: theme.typography['fixedWidth'],
  fontSize: '0.7em',
  fontWeight: '700',
  minWidth: '14px',
  textAlign: 'right',
}));

const TaskPriority = ({task}) => (
  <Holder {...(task.notes?.length > 0 ? {className: 'noted'} : {})}>
    <Description/>
    <Count>{task.notes?.length}</Count>
  </Holder>
);

export default TaskPriority;
